import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '@/store';
import type { ChatHistory } from '@/types/chat';

export function useNotifications() {
  const chats = useSelector((state: RootState) => state.chat.chats);
  const currentPersona = useSelector((state: RootState) => state.app.currentPersona);
  
  // Filter chats with unread messages
  const unreadChats = chats.filter((chat: ChatHistory) => 
    chat.unreadCount > 0 && 
    currentPersona && 
    chat.personaName !== currentPersona.name
  );

  // Show browser notifications when new messages arrive
  useEffect(() => {
    if (unreadChats.length > 0 && 'Notification' in window && Notification.permission === 'granted') {
      unreadChats.forEach((chat: ChatHistory) => {
        new Notification(`New message from Persona ${chat.personaName}`, {
          body: `You have ${chat.unreadCount} unread message/s`,
          icon: '/vite.svg',
          tag: `persona-${chat.personaName}`,
        });
      });
    }
  }, [unreadChats]);

  // Request notification permissions
  const requestNotificationPermission = async () => {
    if ('Notification' in window && Notification.permission === 'default') {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }
    return Notification.permission === 'granted';
  };

  return {
    unreadChats,
    totalUnreadCount: unreadChats.reduce((sum: number, chat: ChatHistory) => sum + chat.unreadCount, 0),
    requestNotificationPermission,
  };
} 